import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-meet-with',
  templateUrl: './meet-with.component.html',
})
export class MeetWithComponent {
  source;
  constructor(private activeRoute: ActivatedRoute) {


    this.source = decodeURI(this.activeRoute.snapshot.params['id']);

    if (this.source == 'pratt') {


      window.location.href = "https://calendly.com/pk-cabbagepay/30min";

    }


    if (this.source == 'denise') {


      window.location.href = "https://calendly.com/denise-fisher/30min";

    }

    else { }

  }

}
